function FilterInsights(){

  jQuery(function(){
      jQuery('.post__tax-list').on('change', function() {
          // jQuery('.portfolio__cat-list_item').removeClass('active');
          // jQuery(this).addClass('active');
          
          let industryterm = jQuery(".tax-industry").val();
          let contentterm = jQuery(".tax-content_type").val();
          let productterm = jQuery(".tax-product_type").val();
            console.log(industryterm,contentterm,productterm);  // get tag ids
          jQuery.ajax({
            type: 'POST',
            url: ajax_posts.ajaxurl,
          // dataType: 'html',
            data: {
              action: 'filter_posts',
              industryterm: industryterm,
              contentterm: contentterm,
              productterm: productterm,
            },
            success: function(res) {
              let resArray = res.split("****");
                // console.log(res); 
                jQuery('.filtered__article').html(" ");
                jQuery('.filtered__article').html(resArray[0]).hide().fadeIn(2000);
                if(resArray[1]<3){
                  jQuery("#load_more_posts").hide();
                }else if(resArray[2]<2){
                  jQuery("#load_more_posts").hide();
                }else{
                  jQuery("#load_more_posts").show();
                  jQuery("#load_more_posts").attr("data-page", "2");
                }
            }
          })
      });

      jQuery(".clear__filter").on("click", function(){
        jQuery(".tax-industry").val("");
        jQuery(".tax-content_type").val("");
        jQuery(".tax-product_type").val("");
        jQuery('.post__tax-list').trigger('change');

      });

  });

}

export default FilterInsights;